/** Keep in sync with App TOOLS + API GenerateFormController::SUPPORTED_TOOLS */
const KNOWN_TOOL_KEYS = new Set([
  "tool-2",
  "tool-3",
  "tool-4",
  "tool-5",
  "tool-6",
  "tool-7",
  "tool-10",
  "tool-12",
  "tool-14",
  "tool-15",
  "tool-16",
  "tool-18",
  "tool-19",
  "tool-20",
  "tool-21",
]);

export function sanitizeFormFields(fields) {
  if (!Array.isArray(fields)) return [];

  return fields.filter((field) => {
    if (!field || typeof field !== "object") return false;
    const entries = Object.entries(field);
    if (!entries.length) return false;
    const [toolKey, toolValue] = entries[0];
    if (!toolKey || !KNOWN_TOOL_KEYS.has(toolKey)) return false;
    if (toolValue == null || typeof toolValue !== "object") return false;
    return true;
  });
}

export function sanitizeProjectForms(forms) {
  if (!Array.isArray(forms)) return [];
  return forms
    .map((form) => {
      if (!form || typeof form !== "object") return null;
      const fields = sanitizeFormFields(form.fields);
      if (!fields.length) return null;
      return { ...form, fields };
    })
    .filter(Boolean);
}
